import React from 'react';
import PropTypes from 'prop-types';
import { Row, Image, CommunityLink } from 'modules/styled';
import { resizeImage } from 'utils/img';

CommunityListItem.propTypes = {
  community: PropTypes.object,
  c: PropTypes.string,
};

function CommunityListItem({ community, c }) {
  const image = community.image
    ? { uri: resizeImage(community.image, 4, 4) }
    : require('public/img/default_community.png');
  return (
    <Row sx={{ alignItems: 'center' }}>
      <Image
        sx={{ width: 5, height: 5, mr: 1.5 * 8.001, bg: image ? 'transparent' : 'grey' }}
        source={image}
        resizeMode={'cover'}
      />
      <CommunityLink sx={{ color: c || 'black' }}>{community.name}</CommunityLink>
    </Row>
  );
}

export default CommunityListItem;
